import { IDataSource } from '@commenda/types/src/datasource/interface';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export function useDatasource(id: string) {
  const url = `datasource/${id}`;

  const { data, error, mutate, isLoading } = useSWR<IDataSource>(
    url,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, mutate, isLoading };
}
